import { connect } from 'react-redux';

import {
  AVM_KEY_USER_ENTERED,
  AVM_KEY_RENTAL_USER_ENTERED,
  VALUE_TYPE_DEFAULT,
  VALUE_TYPE_RENTAL
} from 'legacy/appstore/constants';
import { EVENTS } from 'legacy/appstore/events';

import {
  avmsChangeSelected,
  avmsUpdateUserEnteredValue,
  avmsUpdateUserEnteredRentalValue,
  avmsRentalChangeSelected
} from 'actions/avms';
import { analyticsEvent } from 'actions/analytics';

import {
  getAvmSelectedKey,
  getAvmSelected,
  getAvmHc,
  getAvmCompsExists,
  getAvmUserEntered,
  getAvmsForAvmSelector,
  getAvmRentalSelectedKey,
  getAvmRentalSelected,
  getAvmRentalCompsExists,
  getAvmsRentalForAvmSelector,
  getAvmRentalUserEntered,
  getAvmSelectorUserEntered,
  getAvmRentalSelectorUserEntered,
  getAvmShowBarChart,
  getAvmRentalShowBarChart,
  getAvmRentalHc,
  getAvmSelectorComps,
  getAvmSelectorRentalComps,
  getIsAvmHcEmpty,
  getAvmSelectorCompsAvg,
  getAvmSelectorRentalCompsAvg
} from 'selectors/avms';
import { getReportStatusIsRecomputing } from 'selectors/report-status';
import { getIsReportEditable } from 'selectors/report-permissions';
import { getFeatureFlagsData } from 'selectors/feature-flags';

import PropertyExplorerValue from 'legacy/components/PropertyExplorerValue';

const avmSelectorsDefault = {
  getSelected: getAvmSelected,
  getSelectedKey: getAvmSelectedKey,
  getHcAvm: getAvmHc,
  hasSelectedComps: getAvmCompsExists,
  getAvmsForAvmSelector: getAvmsForAvmSelector,
  getUserEntered: getAvmUserEntered,
  getSelectorUserEntered: getAvmSelectorUserEntered,
  getShowBarChart: getAvmShowBarChart,
  getCompsValueSelector: getAvmSelectorComps,
  getCompsAvgSelector: getAvmSelectorCompsAvg
};
const avmActionsDefault = {
  changeSelected: avmsChangeSelected,
  updateUserEnteredValue: avmsUpdateUserEnteredValue
};

const avmSelectorsRental = {
  getSelected: getAvmRentalSelected,
  getHcAvm: getAvmRentalHc,
  getSelectedKey: getAvmRentalSelectedKey,
  hasSelectedComps: getAvmRentalCompsExists,
  getAvmsForAvmSelector: getAvmsRentalForAvmSelector,
  getUserEntered: getAvmRentalUserEntered,
  getSelectorUserEntered: getAvmRentalSelectorUserEntered,
  getShowBarChart: getAvmRentalShowBarChart,
  getCompsValueSelector: getAvmSelectorRentalComps,
  getCompsAvgSelector: getAvmSelectorRentalCompsAvg
};
const avmActionsRental = {
  changeSelected: avmsRentalChangeSelected,
  updateUserEnteredValue: avmsUpdateUserEnteredRentalValue
};

const DATA_HC_NAMES = {
  [VALUE_TYPE_DEFAULT]: {
    section: 'valuation-section',
    adjustLink: 'valuation-adjust-link',
    adjustPanel: 'valuation-adjust-panel',
    valueHeader: 'valuation-header-text',
    seeMoreLink: 'valuation-see-more-link',
    value: 'valuation-avm-value',
    barChart: 'valuation-bar-chart',
    tooltip: 'valuation-tooltip',
    tooltipText: 'valuation-tooltip-text',
    tooltipClose: 'valuation-tooltip-close'
  },
  [VALUE_TYPE_RENTAL]: {
    adjustLink: 'rental-valuation-adjust-link',
    adjustPanel: 'select-rental-value-panel',
    value: 'rental-valuation',
    valueHeader: 'rental-valuation-header',
    barChart: 'rental-valuation-bar-chart'
  }
};

const mapStateToProps = (state, ownProps) => {
  const { valueType = VALUE_TYPE_DEFAULT } = ownProps;
  const avmSelectors =
    valueType === VALUE_TYPE_DEFAULT ? avmSelectorsDefault : avmSelectorsRental;
  const selectedAvmKey = avmSelectors.getSelectedKey(state);
  const selectedAvm = avmSelectors.getSelected(state);
  const isAvmHcEmpty = getIsAvmHcEmpty(state);
  const isReportEditable = getIsReportEditable(state);
  const featureFlags = getFeatureFlagsData(state);

  return {
    avmKeyUserEntered:
      valueType === VALUE_TYPE_DEFAULT
        ? AVM_KEY_USER_ENTERED
        : AVM_KEY_RENTAL_USER_ENTERED,
    isLoadingUserValue: getReportStatusIsRecomputing(state),
    selectedAvm: selectedAvm,
    avmsForSelector: avmSelectors.getAvmsForAvmSelector(state),
    avmHc: avmSelectors.getHcAvm(state),
    isReportEditable: isReportEditable,
    isReadOnly: !isReportEditable,
    showAvmChart: avmSelectors.getShowBarChart(state),
    isAvmHcEmpty,
    selectedAvmKey,
    className: ownProps.className,
    avmSelectorUserEntered: avmSelectors.getSelectorUserEntered(state),
    hideLearnMore: !avmSelectors.getShowBarChart(state),
    dataHcNames: DATA_HC_NAMES[valueType],
    isMonthlyValue: valueType === VALUE_TYPE_RENTAL,
    avmSelectorCompsValue: avmSelectors.getCompsValueSelector(state),
    avmSelectorCompsAvg: avmSelectors.getCompsAvgSelector(state),
    valueType,
    offerNowAvailable: featureFlags['offer-now']
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { valueType = VALUE_TYPE_DEFAULT } = ownProps;
  const avmActions =
    valueType === VALUE_TYPE_DEFAULT ? avmActionsDefault : avmActionsRental;
  return {
    handleChangeUserEnteredValue: (value) => {
      dispatch(avmActions.updateUserEnteredValue(value));
    },
    handleSelect: (avmKey) => {
      dispatch(avmActions.changeSelected(avmKey));
    },
    trackOpenAvmSelector: () => {
      dispatch(
        analyticsEvent(
          valueType === VALUE_TYPE_DEFAULT
            ? EVENTS.AVM_OPEN_SELECTOR
            : EVENTS.RENTAL_AVM_OPEN_SELECTOR
        )
      );
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyExplorerValue);
